import React, { Component } from 'react';
import { Checkbox, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import ReactTable from 'Common/ReactTableWrapper';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { OnHandReportListingEnum, SiteEnum } from 'Common/FieldEnum';
import { ReactTableWrapperColumnProperties } from 'Common/Constants';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';

import { getOnHandItems, clearOnHandItems } from '../../state/actions';
import * as OnHandListingSelectors from '../../state/selectors';

class SiteGrid extends Component {
  static propTypes = {
    getOnHandItems: PropTypes.func.isRequired,
    clearOnHandItems: PropTypes.func.isRequired,
    filterValues: PropTypes.object.isRequired,
    setSiteGridInstance: PropTypes.func,
    reactTableRef: PropTypes.object,
  };

  static defaultProps = {
    setSiteGridInstance: () => {},
    reactTableRef: null,
  };

  columns = [
    {
      Header: currentRows => {
        const {
          input: { value },
        } = this.props;
        const dataObjs = currentRows.data;
        let filteredData = [];
        let checkAllIds = [];
        _.forEach(dataObjs, obj => {
          const id = obj[SiteEnum.Id]
            ? obj[SiteEnum.Id]
            : obj._original[SiteEnum.Id];
          if (value.indexOf(id) === -1) {
            filteredData.push(id);
          } else {
            checkAllIds.push(id);
          }
        });
        return (
          <Checkbox
            style={{ marginTop: 10 }}
            checked={Boolean(
              dataObjs.length > 0 && checkAllIds.length === dataObjs.length
            )}
            onClick={(e, data) => {
              this.handleHeaderLevelCheckBox(
                filteredData,
                data.checked,
                dataObjs
              );
            }}
          />
        );
      },
      Cell: props => {
        const { original } = props;
        return (
          <div style={{ textAlign: 'center' }}>
            <Checkbox
              checked={
                this.props.input.value.indexOf(original[SiteEnum.Id]) !== -1
              }
              onClick={(e, data) => {
                this.handleChangeCheckbox(original, data.checked);
              }}
            />
          </div>
        );
      },
      accessor: SiteEnum.IsSelected,
      ...ReactTableWrapperColumnProperties,
      sortable: false,
      filterable: false,
    },
    {
      Header: 'Site Id',
      accessor: SiteEnum.Id,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: () => {
        return (
          <span>
            Site
            <br />
            Description
          </span>
        );
      },
      visibilityName: 'Site Description',
      accessor: SiteEnum.Description,
      ...ReactTableWrapperColumnProperties,
    },
  ];

  rowInfo = {
    checked: false,
    original: null,
  };

  onFilteredChange = _.debounce(
    filtered => {
      const { filterValues, getOnHandItems } = this.props;
      const payload = {
        ...filterValues,
        SiteIds: this.getFilteredSelectedSites(),
      };
      getOnHandItems(payload);
    },
    500,
    { leading: false }
  );

  handleHeaderLevelCheckBox = (data, checked, dataObjs) => {
    const {
      filterValues,
      getOnHandItems,
      clearOnHandItems,
      input,
    } = this.props;
    const tableRows = [...input.value, ...data];
    const remove = [...tableRows];
    const checkedSites = [];
    _.forEach(dataObjs, obj => {
      const id = obj[SiteEnum.Id]
        ? obj[SiteEnum.Id]
        : obj._original[SiteEnum.Id];
      const index = remove.indexOf(id);
      if (index !== -1) {
        remove.splice(index, 1);
        checkedSites.push(id);
      }
    });
    if (checked) {
      this.props.input.onChange(tableRows);
      getOnHandItems({
        ...filterValues,
        SiteIds: checkedSites,
      });
    } else {
      this.props.input.onChange(remove);
      getOnHandItems({
        ...filterValues,
        SiteIds: [],
      });
    }

    clearOnHandItems();
  };

  handleChangeCheckbox = (original, checked) => {
    const {
      input,
      filterValues,
      getOnHandItems,
      clearOnHandItems,
    } = this.props;
    if (input && input.value) {
      const formValues = input.value.length ? [...input.value] : [];
      const index = formValues.indexOf(original[SiteEnum.Id]);
      if (checked && index === -1) {
        formValues.push(original[SiteEnum.Id]);
      } else if (index > -1) {
        formValues.splice(index, 1);
      }
      this.props.input.onChange(formValues);
      const payload = {
        ...filterValues,
        SiteIds: this.getFilteredSelectedSites(formValues),
      };
      delete payload[OnHandReportListingEnum.ItemIds];
      getOnHandItems(payload);
    }
    clearOnHandItems();
  };
  getFilteredSelectedSites = formValues => {
    const { allSitesData, input, reactTableRef } = this.props;
    const checkedSiteOrders = [];
    const dataObjs =
      reactTableRef && reactTableRef.current
        ? reactTableRef.current.getResolvedState()
        : { sortedData: allSitesData };
    _.forEach(dataObjs.sortedData, obj => {
      const id = obj[SiteEnum.Id]
        ? obj[SiteEnum.Id]
        : obj._original[SiteEnum.Id];
      if (formValues) {
        formValues.indexOf(id) !== -1 && checkedSiteOrders.push(id);
      } else if (input.value.indexOf(id) !== -1) {
        checkedSiteOrders.push(id);
      }
    });
    return checkedSiteOrders;
  };

  render() {
    const {
      loadingAllSites,
      allSitesData,
      setSiteGridInstance,
      reactTableRef,
    } = this.props;
    return (
      <Form.Field>
        <ReactTable
          minRows={0}
          defaultPageSize={20}
          loading={loadingAllSites}
          data={allSitesData}
          resizable={true}
          className={'-striped -highlight modalGrid'}
          defaultFilterMethod={caseInsensitiveFilter}
          columns={this.columns}
          noDataText={loadingAllSites ? '' : 'No sites found'}
          loadingText={loadingAllSites ? 'Loading...' : ''}
          menu={false}
          saveState={{
            tableName: TableNamesEnum.ON_HAND_REPORT_SITE_GRID_TABLE,
          }}
          onRef={setSiteGridInstance}
          reactTableRef={reactTableRef}
          onFilteredChange={this.onFilteredChange}
        />
      </Form.Field>
    );
  }
}

const mapStateToProps = state => {
  return {
    loadingAllSites: OnHandListingSelectors.getLoadingAllSites(state),
    allSitesData: OnHandListingSelectors.getAllSitesData(state),
  };
};

const mapDispatchToProps = {
  getOnHandItems,
  clearOnHandItems,
};

export const SiteGridContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SiteGrid);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/containers/onhandreportlisting/SiteGridContainer.js